import { withI18n } from '../../hotels-utils/services/i18n';
import { getPricePolicyText } from '../../hotels-utils/services/price-policy/price-policy';

import type {
  HotelPricePolicy as HotelPricePolicyValue,
  I18n,
} from '@skyscanner-internal/landing-pages-shared-types/types-shared/hotels-components/types';

type HotelPricePolicyProps = {
  i18n: I18n;
  pricePolicy: HotelPricePolicyValue;
};

const HotelPricePolicy = ({ i18n, pricePolicy }: HotelPricePolicyProps) => (
  <span>{getPricePolicyText(pricePolicy, i18n)}</span>
);

export default withI18n(HotelPricePolicy);
